import { ECardType } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

const importKeyColumn = 'ID';

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[importKeyColumn],
            header: {
                title: row['title'],
                text: row['description']
            }
        },
        cards: [
            {
                type: ECardType.LINK,
                links: [
                    {
                        title: row['link_title'],
                        url: row['link_url']
                    }
                ]
            }
        ]
    };

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[importKeyColumn]?.toLowerCase();
}

export const ovOlomouc2024ProgramImportMethods = { duplicateChecker, parser, importKeyColumn };
